import { Route, Routes } from 'react-router-dom';

import { Product as ProductView } from './views/Product';
import { Edit } from './views/Edit';
import { Flex } from '../GlobalComponents/Flex';
import { Outer } from '../Layout/Router/Outer';

export const Product: React.FC = () => (
	<Flex $flexDirection="column" $padding="16px 0" $alignItems="center">
		<Routes>
			<Route path="/" element={<Outer />}>
				<Route path="/:id/*" element={<ProductView />} />

				<Route path="/edit/:id/*" element={<Edit />} />
			</Route>
		</Routes>
	</Flex>
);
